import Handler from '@/core/domain/usecase/handler';

const fetchCityRepository = (axios) => async (pagination) => {
    try {
        const response = await axios.get('/city', {
            params: pagination
        })
        return response.data
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchCityRepository